import { Badge } from "@mui/material";
import chroma from "chroma-js";
import { FC, ReactNode } from "react";
type Props = { backgroudColor?: string, children: ReactNode, badgeContent?: string, hidden?: boolean };

export const CustomColorBadge: FC<Props> = ({ children, backgroudColor, badgeContent, hidden = false }) => {
    if (hidden) return <>{children}</>
    if (backgroudColor) {
        const textColour = chroma(backgroudColor).luminance() > 0.5 ? "black" : "white";
        return (
            <Badge sx={{
                "& .MuiBadge-badge": {
                    backgroundColor: backgroudColor,
                    color: textColour,
                    right: 17,
                    bottom: 17,
                }
            }} badgeContent={badgeContent} anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}>
                {children}
            </Badge>
        )
    } else {
        return (
            <Badge color="secondary" badgeContent={badgeContent} anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}>
                {children}
            </Badge>
        )
    }
}